import { useBlocNext } from "@blac/react";
import type { FC } from "react";
import React, { useEffect, useRef } from "react";
import type FunnelKey from "src/constants/funnelKey";
import { tracker } from "src/state/state";
import { ConversionEvent } from "src/state/Track/TrackCubit";
import type { SignupCustomStep } from "src/ui/components/SignupCustomContent/SignupCustom.types";
import SignupCustomStepAuthentication from "src/ui/components/SignupCustomContent/steps/SignupCustomStepAuthentication";
import SignupCustomStepEmailVerification from "src/ui/components/SignupCustomContent/steps/SignupCustomStepEmailVerification";
import SignupCustomStepInfoPageCustomRender from "src/ui/components/SignupCustomContent/steps/SignupCustomStepInfoPageCustomRender";
import SignupCustomStepQuestionnaire from "src/ui/components/SignupCustomContent/steps/SignupCustomStepQuestionnaire";
import SignupCustomStepShippingAddressRender from "src/ui/components/SignupCustomContent/steps/SignupCustomStepShippingAddressRender";
import SignupCustomStepSuccess from "src/ui/components/SignupCustomContent/steps/SignupCustomStepSuccess";
import SignupCustomStepAction from "./steps/SignupCustomStepAction";
import SignupCustomStepAuthConsent from "./steps/SignupCustomStepAuthConsent";
import SignupCustomBloc from "./state/SignupCustomBloc";

export interface SignupCustomStepProps {
  step: SignupCustomStep;
  onStepCompleted: (step: SignupCustomStep) => Promise<boolean> | boolean;
  funnelKey?: FunnelKey | string;
}

const RenderSignupCustomStep: FC<{
  step: SignupCustomStep | undefined;
  onStepCompleted: (
    step: SignupCustomStep,
    data?: unknown
  ) => Promise<boolean> | boolean;
  funnelKey?: FunnelKey | string;
}> = React.memo(({ step, onStepCompleted, funnelKey }) => {
  const [, { completeTransition }] = useBlocNext(SignupCustomBloc);
  const isLoading = !step;

  const stepProps: SignupCustomStepProps | undefined = step
    ? { step, onStepCompleted }
    : undefined;

  if (stepProps) {
    stepProps.funnelKey = funnelKey;
  }

  const tracked = useRef(false);
  useEffect(() => {
    if (!tracked.current) {
      tracker.trackConversion({
        event: ConversionEvent.FunnelStarted
      });
      tracked.current = true;
    }
  }, []);

  useEffect(() => {
    if (step) {
      completeTransition();
    }
  }, [step?.path, completeTransition]);

  if (isLoading || !stepProps) {
    return <h2>Loading...step</h2>;
  }

  return (
    <>
      <SignupCustomStepQuestionnaire {...stepProps} />
      <SignupCustomStepAuthentication {...stepProps} />
      <SignupCustomStepEmailVerification {...stepProps} />
      <SignupCustomStepAuthConsent {...stepProps} />
      <SignupCustomStepShippingAddressRender {...stepProps} />
      <SignupCustomStepSuccess {...stepProps} />
      <SignupCustomStepInfoPageCustomRender {...stepProps} />
      <SignupCustomStepAction {...stepProps} />
    </>
  );
});

export default RenderSignupCustomStep;
